import React from "react";
import { cls } from "app/utils";
import { DateTime } from "luxon";

import useCalendarPreferences from "app/utils/hooks/useCalendarPreferences";
import { formatTime } from "app/utils/luxonFormats";
import styles from "./styles.module.scss";
import { titleWithLabel } from "./titleWithLabel";
import {
  resourceCardLines,
  resourceCardTitle,
  resourceLineShown,
} from "./cardLabels";

type PropsDef = {
  event: any;
  timeText: string;
  timeZone?: string;
  // The bay of the hold, on the time line. The Coaches view only.
  resourceLabel?: string;
  // The coach of the hold, on a line of its own. The Resources view only.
  coachName?: string;
  // True while the facility calendar draws the bay columns.
  facilityResourceView?: boolean;
};

export default function TimeSlotReservation(props: PropsDef) {
  const { durationInMinutes } = props.event.extendedProps;
  const { preferences } = useCalendarPreferences();
  const startTimeString = formatTime(
    DateTime.fromJSDate(props.event.start, { zone: props.timeZone }),
    preferences.timeFormat,
  );

  // In the Resources view, the height of the card sets which lines show (see
  // `resourceCardLines`). A hold has no athlete line.
  const isResourceCard = props.facilityResourceView === true;
  const lines = resourceCardLines(props.coachName, durationInMinutes);
  const titleText = isResourceCard
    ? resourceCardTitle(props.event.title, props.coachName, lines)
    : titleWithLabel(props.event.title, props.resourceLabel, durationInMinutes);
  const showTimeLine = !isResourceCard || lines.timeLine;

  return (
    <div
      className={`${styles.event_container} ${
        durationInMinutes < 30 ? styles.small_event : ""
      }`}
    >
      <div className={styles.time_slot_reservation_bar}></div>

      <div
        className={cls(styles.lesson_schedule_event, {
          [styles.lesson_schedule_event_resource]: isResourceCard,
        })}
      >
        <div className={styles.time_slot_reservation_title}>{titleText}</div>
        {isResourceCard && lines.coachLine && (
          <div className={styles.event_coach}>{props.coachName}</div>
        )}
        {showTimeLine && (
          <div className={styles.event_time}>
            {resourceLineShown(props.resourceLabel, durationInMinutes)
              ? `${startTimeString} \u00B7 ${props.resourceLabel}`
              : startTimeString}
          </div>
        )}
      </div>
    </div>
  );
}
